"use strict";

const state = {
  // fullName: { firstName: "omar", lastName: "mhiri" },
  productDetail:{},
  productModalState:false
};

const getters = {
};

const mutations = {
};

const actions = {
};

export default {
  state,
  getters,
  actions,
  mutations,
};
